import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { BiFile } from 'react-icons/bi';
import { BsUpload } from 'react-icons/bs';
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import MessageModal from "../../../components/MessageModal/MessageModal";
import { DATA_COLLECTION_IMPORT_POLLING_INTERVAL, LS_AUTHORITY_KEY, LS_REGULATION_SELECTED_KEY } from '../../../core/constants/common';
import CompanyService from '../../../core/service/CompanyService';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import Utils from '../../../core/utilities/Utils';
import './GHGEmissions.scss';

const ImportTemplate = ({ t, gotoNext, entity }) => {

	const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
	const companyId = lsDat.profile.company.id;
    const glbRegulationId = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
    const { setLoaderDisplay } = useContext(LoaderContext);
    const [filterDisplay, setFilterDisplay] = useState(true);
    const [parentEntities, setParentEntities] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef();
    const [childEntities, setChildEntities] = useState([]);
    const [importInProgress, setImportInProgress] = useState(false);
    let importStatusPoller;
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [title, setTitle] = useState(t("ImportMessage.label"));
    const [modalMessage, setModalMessage] = useState("Test Message");

    useEffect(() => {
        if (!glbRegulationId) return;
        getEnterprisesByLevel(1);
        getEnterprisesByLevel(2);
    }, [glbRegulationId]);

    useEffect(() => {
        fetchImportStatus(true);
        return () => {
            // On unmounting
            clearImportStatusPoller();
        };
    }, []);

    const onFileSelect = (e) => {
        e.preventDefault();
        setFile(e.target.files[0]);
    };

    const importTem = () => {
        if (file && selectedEntity) {
            const formData = new FormData();
            formData.append("file", file);
            setLoaderDisplay(true);
            GHGEmissionService.uploadTemplate(formData, companyId, selectedEntity, glbRegulationId)
                .then((response) => {
                    toast.success(response.data, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    removeFile();
                    fetchImportStatus(true);
                })
                .catch((error) => {
                    setLoaderDisplay(false);
                })
                .finally(() => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning('Please choose file and entity', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };


    const getEnterprisesByLevel = (level) => {
        CompanyService.getEnterprisesByLevel(level).then(res => {
            if (res.status !== 200) return;
            const entities = res.data.sort((a, b) => a.sortOrder - b.sortOrder);
            if (level === 1) {
                setParentEntities(entities);

            } else if (level === 2) {
                setChildEntities(entities);
            }
        }).catch(err => { });
    };

    const fetchImportStatus = (startPoller = false) => {
        GHGEmissionService.checkImport(companyId).then(res => {
            if (res.data) {
                setImportInProgress(true);
                if (!startPoller) return;
                startImportStatusPoller();
            } else {
                clearImportStatusPoller();
            }
        }).catch(err => {
            clearImportStatusPoller();
        });
    };


    const startImportStatusPoller = () => {
        importStatusPoller = setTimeout(function request() {
            fetchImportStatus();
            importStatusPoller = setTimeout(request, DATA_COLLECTION_IMPORT_POLLING_INTERVAL);
        }, DATA_COLLECTION_IMPORT_POLLING_INTERVAL);
    };

    const clearImportStatusPoller = () => {
        setImportInProgress(false);
        if (!importStatusPoller) return;
        clearTimeout(importStatusPoller);
    };

    const renderFilter = () => {
        return (
            <div className={`FileFilterBox ${filterDisplay ? 'filter-holder' : 'd-none'}`}>
                <div className="filter-holder_body">
                    <div className="p-2">
                        <label>{t("Entity.label")}</label>
                        <select className="form-select"
                            onChange={(e) => {
                                setSelectedEntity(e.target.value);
                            }}>
                            <option key='' value=''>{t("Select.label")}</option>
                            {
                                parentEntities?.map((items) => (
                                    <option value={items.id} key={items.id}>
                                        {items.name}
                                    </option>
                                ))
                            }
                            {
                                childEntities?.map((items) => (
                                    <option value={items.id} key={items.id}>
                                        {items.name}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                    <div className='p-2'>
                        <label className='mb-1'>{t("File.label")}</label>
                        <div className='d-flex mb-1'>
                            <input
                                className='form-control'
                                type="file"
                                accept=".xlsx"
                                onChange={(e) => onFileSelect(e)}
                                onClick={(e) => {
                                    e.target.value = null;
                                }}
                                ref={fileInputRef}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    const removeFile = () => {
        fileInputRef.current.value = null;
        setFile(null);
    }

    const gotoNextPage = () => {
        entity(selectedEntity);
        gotoNext('view');
    }

    const callbackMessageModal = (boolVal) => {
        if (boolVal) {
            importTem();
        }
        setShowMessageModal(false);
    };

    return (
        <div>
            <div className='import_customCreate_viewBox'>

                <div className='import_customBOx'>
                    <h5>{t("SelectTheEntityandFile.label")}</h5>
                    {renderFilter()}

                    {
                        file &&
                        <div className='File_uploadView'>
                            <div className='File_uploadView_in mb-2'>
                                <div className='File_uploadView_box'>
                                    <div className='file-image'>
                                        <BiFile />
                                    </div>
                                    <div className='file_ulpoad_dt01'>
                                        <div>
                                            <h6>{file?.name}</h6>
                                            <ul>
                                                <li>xlsx</li>
                                                <li>{Utils.formattedNumber(file.size / (1024 * 1024))} MB</li>
                                                <li>
                                                    <Button className='Upladfile-action-delete' onClick={() => removeFile()}>{t("Delete.label")}</Button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        file &&
                        <div>
                            <label><b>Note:</b></label><br />
                            <label>If data exists for selected criteria, it will be overwritten.</label>
                            <label>Rows having same period and item will be merged with sum of quantity and cost.</label>
                        </div>
                    }
                </div>

                {/* <div className='import_customBOx'>
                    <img src={UploadImg} />
                    <h4>Click here to import a custom classification</h4>

                    <p>Supported format : .xlsx</p>
                    <input type='file' className='file-upload-input' onChange={(e) => onFileSelect(e)}
                        onClick={(e) => { e.target.value = null; }} accept=".xlsx" ref={fileInputRef} />
                </div> */}

                <div className='text-center p-2'>
                    {/* <Button variant='secondary' className='px-3 me-2'>Back</Button> */}
                    <Button variant='primary' className='px-3' onClick={() => importTem()} disabled={importInProgress}>
                        {
                            importInProgress
                                ?
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="px-1">{t('ImportInProgress.label')}</span>
                                </>
                                :
                                <>
                                    <BsUpload /> <span>{t("Import.label")}</span>
                                </>
                        }
                    </Button>&nbsp;&nbsp;
                    <Button variant='secondary' className='px-3' onClick={() => gotoNextPage()}>{t("Next.label")}</Button>
                </div>

            </div>

            {showMessageModal && (
                <MessageModal
                    modalShow={true}
                    messageText={modalMessage}
                    callbackModal={(val, id) => callbackMessageModal(val)}
                    id=""
                    title={title}
                    buttonText={t("Proceed.label")}
                />
            )}
        </div>
    );
};

export default withTranslation()(ImportTemplate);